import TimeOffRequestsTable from "../../components/HR/TimeOffRequestsTable/TimeOffRequestsTable";

const TimeOffRequestsPage = () => {
  return <TimeOffRequestsTable />;
};

export default TimeOffRequestsPage;
